<template>
  <div>
    <!-- ── MOBILE FOOTER ── -->
    <footer class="footer-mobile" v-if="isMobileOrTablet">
      <div class="footer-mobile-inner">
        <div class="footer-brand">
          <span class="footer-copy-text">
            <font-awesome-icon icon="copyright" class="inline" />
            1998-{{ currentYear }} Divvy Engagement Solutions
          </span>
        </div>
        <div class="footer-lang-mobile">
          <Translator :countries="countries" class="languages-mobile" />
        </div>
      </div>

      <!-- Feedback Modal -->
      <b-modal id="feedback" size="lg" title="Feedback">
        <p>
          If you have any comments or problems with IncentiWeb, please fill out
          this form and one of our representatives will respond.
        </p>
        <div class="alert alert-info bg-warning-50 p-2">
          <font-awesome-icon class="mr-2" icon="envelope" />
          <strong>Please verify that your email address is correct.</strong>
        </div>
        <b-form>
          <div class="row col-12 mr-0 pr-0">
            <div class="col-12 col-sm-6">
              <label>E-mail</label>
              <b-form-input v-model="email" class="form-control mb-2" required type="email"></b-form-input>
              <div class="invalid-feedback">A valid name is required.</div>
              <label>Order Number</label>
              <b-form-input v-model="orderNumber" class="form-control mb-2" type="number"></b-form-input>
            </div>
            <div class="col-12 col-sm-6">
              <label>Daytime Phone</label>
              <b-form-input v-model="phone" class="form-control mb-2" required type="tel"></b-form-input>
              <label>Mobile phone</label>
              <b-form-input v-model="mobile" class="form-control mb-2" type="tel"></b-form-input>
            </div>
          </div>
          <div class="row col-12">
            <div class="col-12 pb-2 pr-0">
              <label>Message</label>
              <b-form-textarea id="textarea" max-rows="6" placeholder="Leave us a message..." rows="3"></b-form-textarea>
            </div>
          </div>
        </b-form>
      </b-modal>
    </footer>

    <!-- ── DESKTOP FOOTER ── -->
    <footer class="footer-desktop" v-else>
      <div class="footer-desktop-inner">

        <!-- Left: Brand + copyright -->
        <div class="footer-left">
          <div class="footer-brand-desktop">
            <span class="footer-dot-accent"></span>
            <span class="footer-brand-name">Divvy Engagement</span>
          </div>
          <p class="footer-copyright">
            <font-awesome-icon icon="copyright" class="inline" />
            1998-{{ currentYear }} Divvy Engagement Solutions
          </p>
        </div>

        <!-- Right: Language -->
        <div class="footer-right">
          <span class="footer-lang-label">Language</span>
          <Translator :countries="countries" class="languages" />
        </div>

      </div>

      <!-- Feedback Modal -->
      <b-modal id="feedback" size="lg" title="Feedback" @ok="SubmitFeedbackForm" @hidden="resetFeedbackForm">
        <p>
          If you have any comments or problems with IncentiWeb, please fill out
          this form and one of our representatives will respond.
        </p>
        <div class="alert alert-info bg-warning-50 p-2">
          <font-awesome-icon class="mr-2" icon="envelope" />
          <strong>Please verify that your email address is correct.</strong>
        </div>
        <b-form>
          <div class="row col-12 mr-0 pr-0">
            <div class="col-12 col-sm-6">
              <label>E-mail</label>
              <b-form-input v-model="email" class="form-control mb-2" required type="email"></b-form-input>
              <div class="invalid-feedback">A valid name is required.</div>
              <label>Order Number</label>
              <b-form-input v-model="orderNumber" class="form-control mb-2"></b-form-input>
            </div>
            <div class="col-12 col-sm-6">
              <label>Daytime Phone</label>
              <b-form-input v-model="phone" class="form-control mb-2" required type="tel"></b-form-input>
              <label>Mobile phone</label>
              <b-form-input v-model="mobile" class="form-control mb-2" type="tel"></b-form-input>
            </div>
          </div>
          <div class="row col-12">
            <div class="col-12 pb-2 pr-0">
              <label>Message</label>
              <b-form-textarea id="textarea" max-rows="6" placeholder="Leave us a message..." rows="3" v-model="message"></b-form-textarea>
            </div>
            <p class="text-danger" v-if="error && error != ''">{{ error }}</p>
            <p v-else-if="success" class="text-success">Successfully sent message!</p>
          </div>
        </b-form>
      </b-modal>
    </footer>
  </div>
</template>

<script>
import { Translator } from "vue-google-translate";
import { isMobile, isTablet } from "mobile-device-detect";

export default {
  computed: {
    isMobileOrTablet: function () {
      return isMobile || isTablet;
    },
  },
  data() {
    return {
      currentYear: new Date().getFullYear(),
      name: "",
      email: "",
      phone: "",
      mobile: "",
      orderNumber: "",
      message: "",
      selected: 0,
      logoSrc:
        "https://www.incentiveweb.com/libertymutual/images/logo_libertymutual_pfp.png",
      userName: "Jean Claude",
      userPoints: "5,500",
      userPointsAvailable: "5,500",
      userAdmin: true,
      ptsCart: "1,000",
      itemsCart: "5",
      itemsWishlist: "5",
      countries: [
        { code: "en|es", title: "Spanish" },
        { code: "en|fr", title: "French" },
        { code: "en|en", title: "English" },
      ],
      error: '',
      success: false,
    };
  },
  components: { Translator },
  methods: {
    async SubmitFeedbackForm(bvModalEvent) {
      this.error = ""
      bvModalEvent.preventDefault();
      console.log({
        email: this.email,
        dayPhone: this.phone,
        mobilePhone: this.mobile,
        orderNumber: this.orderNumber,
        message: this.message,
      });
      try {
        const resp = await this.$store.dispatch("contact/postMessage", {
          email: this.email,
          dayPhone: this.phone,
          mobilePhone: this.mobile,
          orderNumber: this.orderNumber,
          message: this.message,
        });
        console.log("-------------")
        console.log(this.orderNumber)
        console.log(resp)
        if (resp.status != 200) {
          this.error = resp.data
          return
        }
        this.success = true
        this.$bvModal.hide('feedback');
        alert("Your inquiry has been submitted successfully!");
      }
      catch (e) {
        console.error(e)
        this.error = e
      }
    },
    resetFeedbackForm() {
      this.email = "";
      this.phone = "";
      this.mobile = "";
      this.orderNumber = "";
      this.message = "";
      this.error = "";
      this.success = false;
    },
  },
};
</script>

<style lang="scss">

/* ══════════════════════════════════════
   GLOBAL STICKY-FOOTER FOUNDATION
   Any page that wraps content in
   .page-layout gets footer pinned to
   the bottom automatically.
══════════════════════════════════════ */
html, body {
  min-height: 100%;
}

/* Desktop sticky footer layout */
.page-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

/* Content shell fills remaining space */
.curated-shell,
.desktop-shell {
  flex: 1 0 auto;
}

/* ══════════════════════════════════════
   DESKTOP FOOTER
══════════════════════════════════════ */
.footer-desktop {
  background-color: #1e1e2e;
  border-top: 1px solid rgba(255,255,255,0.06);
  width: 100%;
  flex-shrink: 0;   /* never compress, always full height */
}

.footer-desktop-inner {
  max-width: 1280px;
  margin: 0 auto;
  padding: 1.1rem 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.footer-left {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.footer-brand-desktop {
  display: flex;
  align-items: center;
  gap: 0.45rem;

  .footer-dot-accent {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: linear-gradient(135deg, #4fc3f7, #0056d2);
    display: inline-block;
    flex-shrink: 0;
  }

  .footer-brand-name {
    font-size: 1rem;
    font-weight: 800;
    color: #ffffff;
    letter-spacing: -0.02em;
  }
}

.footer-copyright {
  font-size: 0.75rem;
  color: rgba(255,255,255,0.72);
  margin: 0;
  display: flex;
  align-items: center;
  gap: 0.35rem;

  svg { font-size: 0.7rem; }
}

.footer-right {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}

.footer-lang-label {
  font-size: 0.72rem;
  font-weight: 600;
  color: rgba(255,255,255,0.35);
  letter-spacing: 0.08em;
  text-transform: uppercase;
  white-space: nowrap;
}


/* ══════════════════════════════════════
   MOBILE FOOTER
══════════════════════════════════════ */
.footer-mobile {
  background-color: #1e1e2e;
  border-top: 1px solid rgba(255,255,255,0.06);
  width: 100%;
  overflow: hidden;
  flex-shrink: 0;
}

.footer-mobile-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  gap: 0.5rem;
  flex-wrap: nowrap;
  overflow: hidden;
}

.footer-brand {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  flex: 1;
  min-width: 0;

  .footer-logo-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: linear-gradient(135deg, #4fc3f7, #0056d2);
    display: inline-block;
    flex-shrink: 0;
  }

  .footer-copy-text {
    font-size: 0.75rem;
    color: rgba(255,255,255,0.72);
    display: flex;
    align-items: center;
    gap: 0.3rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    svg { font-size: 0.65rem; flex-shrink: 0; }
  }
}

.footer-lang-mobile {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}


/* ══════════════════════════════════════
   LANGUAGE SWITCHER
══════════════════════════════════════ */
.languages {
  display: flex;
  flex-basis: content;

  .grid.md\:grid-cols-2.lg\:grid-cols-3.p-4.shadow.m-4.rounded-lg {
    display: flex;
    flex-direction: row;
    margin: 0 !important;
    padding: 0 !important;
    box-shadow: none !important;
  }

  .py-2 { display: -webkit-inline-box; }
  .language__text { display: none; }

  .language-item {
    margin-right: 6px;
    margin-left: 6px;

    img {
      width: 22px;
      height: 22px;
      border-radius: 3px;
      opacity: 0.75;
      transition: opacity 0.2s;
      display: block;
      &:hover { opacity: 1; }
    }
  }
}

.languages-mobile {
  display: flex;
  flex-basis: content;

  .grid.md\:grid-cols-2.lg\:grid-cols-3.p-4.shadow.m-4.rounded-lg {
    display: flex;
    flex-direction: row;
    margin: 0 !important;
    padding: 0 !important;
    box-shadow: none !important;
  }

  .py-2 { display: -webkit-inline-box; }
  .language__text { display: none; }

  .language-item {
    margin-right: 3px;
    margin-left: 3px;

    img {
      width: 18px;
      height: 18px;
      border-radius: 3px;
      opacity: 0.75;
      transition: opacity 0.2s;
      display: block;
      &:hover { opacity: 1; }
    }
  }
}
</style>